<template>
  <v-card class="app-card" outlined flat v-bind="$attrs" v-on="$listeners">
    <div v-if="$slots.header" class="app-card__header">
      <slot name="header" />
    </div>

    <div v-if="$slots.header || $slots.content" class="divider" />

    <div v-if="$slots.content" class="app-card__content">
      <slot name="content" />
    </div>

    <div v-if="$slots.footer" class="divider" />

    <div v-if="$slots.footer" class="app-card__footer">
      <slot name="footer" />
    </div>

    <slot v-if="!$slots.header && !$slots.content && !$slots.footer" />
  </v-card>
</template>

<script>
export default {
  name: 'AppCard',
}
</script>

<style scoped>
.app-card {
  border-radius: 14px !important;
  overflow: hidden !important;
}

.app-card__header,
.app-card__content,
.app-card__footer {
  padding: 16px 24px;
}

.divider {
  border-top: 1px solid #e0e0e0;
}
</style>
